import { HStack, Icon, StackProps, Text } from "@chakra-ui/react";
import { RiCheckboxCircleLine } from "@remixicon/react";

interface Props extends StackProps {
  title?: string;
  textStyle?: string;
}

export const ProductAdded = ({
  title = "Sudah ditambahkan",
  textStyle = "h-subtitle",
  ...rest
}: Props) => {
  return (
    <HStack {...rest}>
      <Icon as={RiCheckboxCircleLine} color={"green.400"} />
      <Text textStyle={textStyle} color={"green.400"}>
        {title}
      </Text>
    </HStack>
  );
};
